import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Deep Hole Drilling',
      description: 'Advanced precision drilling technology for complex industrial applications with exceptional accuracy and efficiency.',
      features: ['High precision', 'Deep penetration', 'Minimal deviation'],
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/DSCF1373-1024x768.jpg',
      link: '/deep-hole-drilling'
    },
    {
      icon: 'ri-contrast-2-line',
      title: 'Honing Technology',
      description: 'State-of-the-art honing processes delivering superior surface finish and dimensional accuracy for critical components.',
      features: ['Mirror finish', 'Tight tolerances', 'Surface integrity'],
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2017/01/tech_reason.jpg',
      link: '#contact'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Gun Drilling Systems',
      description: 'Cutting-edge gun drilling machinery and solutions for demanding applications across multiple industries.',
      features: ['Fast processing', 'Long reach', 'Consistent quality'],
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/Untitled-17.png',
      link: '/gun-drilling-systems'
    },
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-[#001E3C] to-[#002A4E] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle, #00D9C9 1px, transparent 1px)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#00D9C9] text-sm font-semibold tracking-wider uppercase">Our Services</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
            Advanced Manufacturing Solutions
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Delivering cutting-edge precision machining technologies that power industries worldwide
          </p>
        </div>

        {/* Services Grid */}
        <div className="space-y-24">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#00D9C9]/10 border border-[#00D9C9] rounded-lg mb-6">
                  <i className={`${service.icon} text-3xl text-[#00D9C9]`}></i>
                </div>
                
                <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
                  {service.title}
                </h3>
                
                <p className="text-lg text-white/70 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Features */}
                <div className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-[#00D9C9] rounded flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-[#001E3C] text-sm"></i>
                      </div>
                      <span className="text-white/90">{feature}</span>
                    </div>
                  ))}
                </div>

                {service.link.startsWith('/') ? (
                  <Link
                    to={service.link}
                    className="group inline-flex items-center gap-2 text-[#00D9C9] font-semibold hover:gap-4 transition-all duration-300 whitespace-nowrap"
                  >
                    Learn More
                    <i className="ri-arrow-right-line text-xl w-6 h-6 flex items-center justify-center"></i>
                  </Link>
                ) : (
                  <a
                    href={service.link}
                    className="group inline-flex items-center gap-2 text-[#00D9C9] font-semibold hover:gap-4 transition-all duration-300 whitespace-nowrap"
                  >
                    Learn More
                    <i className="ri-arrow-right-line text-xl w-6 h-6 flex items-center justify-center"></i>
                  </a>
                )}
              </div>

              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="relative group">
                  <div className="absolute inset-0 bg-[#00D9C9]/20 rounded-lg blur-xl group-hover:blur-2xl transition-all duration-500"></div>
                  <div className="relative rounded-lg overflow-hidden border border-white/10">
                    <div className="w-full h-[400px]">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-[#001E3C] via-transparent to-transparent opacity-60"></div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
